
import { useState, useEffect } from 'react';
import { BusinessFormData } from '../types';

export const useFormChanges = (formData: BusinessFormData, initialFormData: BusinessFormData) => {
  // Track form changes
  const [formChanged, setFormChanged] = useState(false);
  
  // Check for changes in form data
  useEffect(() => {
    if (Object.keys(initialFormData).length === 0) return;
    
    const hasChanges = Object.keys(formData).some(key => {
      const fieldKey = key as keyof typeof formData;
      
      // Convert values to strings for comparison, handling null and undefined
      const currentValue = formData[fieldKey] !== null && formData[fieldKey] !== undefined 
        ? String(formData[fieldKey]) 
        : '';
        
      const initialValue = initialFormData[fieldKey] !== null && initialFormData[fieldKey] !== undefined 
        ? String(initialFormData[fieldKey]) 
        : '';
      
      return currentValue !== initialValue;
    });
    
    setFormChanged(hasChanges);
  }, [formData, initialFormData]);

  return { formChanged, setFormChanged };
};
